import React, { useRef } from "react";
import type { EligibilityPrompt } from "@poscon/shared-types/eram";
import {
  EligibilityOverridePrompt as BaseEligibilityOverridePrompt,
  eligibilityOverrideView,
  setEligibilityPrompt,
} from "@poscon/shared-frontend";
import type { Container as PixiContainer } from "pixi.js";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { processEramMessage } from "~redux/thunks/processEramMessage";
import { setViewPosition, viewPositionSelector } from "~redux/slices/eramStateSlice";
import { useDragging } from "hooks/useDragging";
import { layerZIndexMap } from "~/layerZIndexMap";
import { useEventMode } from "components/utils/InteractiveContainer";

const view = eligibilityOverrideView;

type EligibilityOverridePromptProps = {
  prompt: EligibilityPrompt;
};

export const EligibilityOverridePrompt = ({ prompt }: EligibilityOverridePromptProps) => {
  const dispatch = useRootDispatch();
  const ref = useRef<PixiContainer | null>(null);
  const pos = useRootSelector((state) => viewPositionSelector(state, view));
  const { startDrag } = useDragging(ref, view);
  const eventMode = useEventMode();

  return (
    <BaseEligibilityOverridePrompt
      ref={ref}
      pos={pos}
      startDrag={startDrag}
      prompt={prompt}
      closePrompt={() => dispatch(setEligibilityPrompt(null))}
      dispatchCommand={(command) => dispatch(processEramMessage(command))}
      setViewPosition={(pos) => dispatch(setViewPosition({ view, pos }))}
      eventMode={eventMode}
      zIndex={layerZIndexMap.prompts}
    />
  );
};
